import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex justify-space-between mb-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("strong", null, "ANNULLA", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("strong", null, "CONFERMA", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    activator: _ctx.activator,
    width: "auto",
    ref: "dialog",
    modelValue: _ctx.isActive,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isActive) = $event)),
    "onClick:outside": _cache[2] || (_cache[2] = ($event: any) => ('persistent' in _ctx.$attrs ? void 0 : _ctx.onClickBackOnce()))
  }, {
    default: _withCtx(({ isActive }) => [
      _createVNode(_component_v_card, { class: "px-8 pt-8 pb-6 d-flex flex-column justify-center" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_card_title, { class: "pa-0" }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "title")
              ]),
              _: 3
            }),
            _createVNode(_component_v_icon, {
              icon: "mdi-window-close",
              color: "grey-darken-2",
              size: "28",
              class: "mt-1",
              onClick: _ctx.onClickBackOnce
            }, null, 8, ["onClick"])
          ]),
          _createElementVNode("div", {
            onKeyup: _cache[0] || (_cache[0] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.onClickBackOnce && _ctx.onClickBackOnce(...args)), ["stop"]), ["esc"])),
            tabindex: "0"
          }, [
            _renderSlot(_ctx.$slots, "content", { isActive: isActive })
          ], 32),
          _createVNode(_component_v_card_actions, {
            class: _normalizeClass(['d-flex', _ctx.removeErrorButton ? 'justify-end' : 'justify-space-between', 'pa-0', 'mt-7']),
            style: {"min-height":"36px"}
          }, {
            default: _withCtx(() => [
              (!_ctx.removeErrorButton)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    onClick: _ctx.onClickBackOnce,
                    color: "grey-darken-1"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_v_btn, {
                disabled: _ctx.disableSuccessButton,
                onClick: _ctx.onClickConfirm,
                color: "success"
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _: 2
      }, 1024)
    ]),
    _: 3
  }, 8, ["activator", "modelValue"]))
}